import { Component, Input, OnInit } from '@angular/core';
import { FieldComponent } from '../form-field/form-field.component';
import { InputType } from '@bo/ng-forms';
import { NgClass } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';

@Component({
  selector: 'app-password-field',
  imports: [FieldComponent, NgClass, TabsModule],
  template: `
    <div class="mb-3">
      <div class="show-password-wrap">
        <app-form-field
          [boFieldPath]="boFieldPath"
          [label]="label"
          [type]="type"
          [placeholder]="placeholder"
          autocomplete="new-password"
          #password></app-form-field>
        @if (!hasFieldErrors()) {
          <i
            (click)="toggleShowPassword()"
            (keyup)="toggleShowPassword()"
            role="button"
            tabindex="{0}"
            [ngClass]="passwordShow ? 'ic-eye' : 'ic-disable-eye'"
            class="pays-icon"></i>
        }
      </div>
      <p
        [ngClass]="showError ? 'text-danger' : 'text-muted'"
        class="small text-muted">
        {{ helpText }}
      </p>
    </div>
  `,
})
export class PasswordFieldComponent extends FieldComponent implements OnInit {
  @Input({ required: true }) override boFieldPath!: string;
  @Input() override label!: string;
  @Input() helpText?: string;
  @Input() override placeholder?: string;
  @Input() showError: boolean = false;
  passwordShow: boolean = false;

  override type: InputType = InputType.password;

  toggleShowPassword() {
    this.type = this.type === InputType.password ? InputType.text : InputType.password;
    this.passwordShow = !this.passwordShow;
  }

  override ngOnInit() {
    super.ngOnInit();
  }
}
